import type {MapaDashboardDto} from '@devmil/contracts';

import {usePanel} from '../../app/PanelProvider.js';

export const useMapaDashboard = (): MapaDashboardDto | null =>
  usePanel().snapshot?.mapa ?? null;
